import * as React from "react";

const TOAST_LIMIT = 1;
const DEFAULT_TOAST_REMOVE_DELAY = 5000;

let count = 0;
const listeners = [];
let memoryState = { toasts: [] };

function genId() {
  count = (count + 1) % Number.MAX_VALUE;
  return count.toString();
}

function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
}

export const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TOAST":
      return {
        ...state,
        toasts: [action.toast, ...state.toasts].slice(0, TOAST_LIMIT),
      };
    case "UPDATE_TOAST":
      return {
        ...state,
        toasts: state.toasts.map((t) =>
          t.id === action.toast.id ? { ...t, ...action.toast } : t
        ),
      };
    case "DISMISS_TOAST":
      return {
        ...state,
        toasts: state.toasts.map((t) =>
          t.id === action.toastId || action.toastId === undefined
            ? { ...t, open: false }
            : t
        ),
      };
  }
};

export function toast(props) {
  const id = props.id || genId();
  const duration =
    typeof props.duration === "number"
      ? props.duration
      : DEFAULT_TOAST_REMOVE_DELAY;

  const dismiss = () =>
    dispatch({
      type: "DISMISS_TOAST",
      toastId: id,
    });

  dispatch({
    type: "ADD_TOAST",
    toast: {
      ...props,
      id,
      open: true,
      onOpenChange: (open) => {
        if (!open) dismiss();
      },
    },
  });

  // Only set auto-dismiss timeout if duration is not Infinity
  if (duration !== Infinity) {
    setTimeout(dismiss, duration);
  }

  // Return functions to update or dismiss this specific toast
  return {
    id,
    dismiss: () => dismiss(),
    update: (props) =>
      dispatch({
        type: "UPDATE_TOAST",
        toast: { ...props, id },
      }),
  };
}

export function useToast() {
  const [state, setState] = React.useState(memoryState);

  React.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);

  return {
    ...state,
    toast,
    dismiss: (toastId) => dispatch({ type: "DISMISS_TOAST", toastId }),
    update: (toastId, props) =>
      dispatch({
        type: "UPDATE_TOAST",
        toast: { ...props, id: toastId },
      }),
  };
}
